/* SportsZone instant predictive search for the custom header */
(() => {
  const SEARCH_FORMS =
    '[data-sz-header] form.sz-header__desktop-search, [data-sz-header] form.sz-header__mobile-search, [data-sz-header] form.sz-header__search-form, form[data-sz-search-page-form]';
  const MIN_CHARS = 2;
  const DEBOUNCE_MS = 160;
  const RECENT_STORAGE_KEY = 'sportszone-smart-search-recent';
  const RECENT_LIMIT = 3;
  const cache = new Map();
  let desktopPopularCollectionsPromise = null;

  // Merchandised from the newest ACTIVE, published, in-stock launches checked Sept. 12, 2026.
  const FRESH_SEARCHES = [
    { label: 'Bauer Supreme Fuse', query: 'Bauer Supreme Fuse Skates' },
    { label: 'CCM Trigger Unleashed', query: 'CCM Trigger Unleashed' },
    { label: 'Easton 2027 Hype Fire', query: '2027 Hype Fire' },
    { label: 'Easton 2027 Ghost OG', query: '2027 Ghost OG' },
    { label: 'Rawlings 2027 Halo', query: 'Rawlings 2027 Halo' },
    { label: 'Bauer Supreme Ignite Pro', query: 'Bauer Supreme Ignite Pro' },
    { label: 'CCM Vizion', query: 'CCM Vizion' },
    { label: 'Warrior Covert Q7 Pro', query: 'Warrior Covert Q7 Pro' },
  ];


  const POPULAR_COLLECTIONS = [
    { label: 'Bauer Supreme Fuse Hockey Skates', query: 'Bauer Supreme Fuse Hockey Skates', url: '/collections/bauer-supreme-fuse-hockey-skates' },
    { label: '2026 Bauer Supreme Ignite Pro Hockey Skates', query: 'Bauer Supreme Ignite Pro Hockey Skates', url: '/collections/2026-bauer-supreme-ignite-pro-hockey-skates-all-sizes' },
    { label: '2026 CCM Vizion Hockey Sticks', query: '2026 CCM Vizion Hockey Sticks', url: '/collections/2026-ccm-vizion-hockey-sticks' },
    { label: 'CCM Vizion Hockey Skates', query: 'CCM Vizion Hockey Skates', url: '/collections/ccm-vizion-hockey-skates' },
    { label: '2027 Easton Hype Fire Baseball Bats', query: '2027 Easton Hype Fire Baseball Bats', url: '/collections/2027-easton-hype-fire-baseball-bats' },
    { label: '2027 Easton Ghost OG Fastpitch Bats', query: '2027 Easton Ghost OG Fastpitch Softball Bats', url: '/collections/2027-easton-ghost-og-fastpitch-softball-bats' },
    { label: '2027 Rawlings Halo Fastpitch Bats', query: '2027 Rawlings Halo Fastpitch Softball Bats', url: '/collections/2027-rawlings-halo-fastpitch-softball-bats' },
    { label: 'Bauer Supreme Fuse Hockey Shoulder Pads', query: 'Bauer Supreme Fuse Hockey Shoulder Pads', url: '/collections/bauer-supreme-fuse-hockey-shoulder-pads' },
  ];

  const escapeHtml = (value = '') =>
    String(value)
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;')
      .replaceAll("'", '&#039;');

  const normalizeImage = (product) => {
    const candidate = product?.featured_image || product?.image || '';
    if (typeof candidate === 'string') return candidate;
    if (candidate && typeof candidate === 'object') {
      return candidate.url || candidate.src || '';
    }
    return '';
  };

  const formatMoney = (value) => {
    if (value === null || value === undefined || value === '') return '';
    const numeric = Number(value);
    if (!Number.isFinite(numeric)) return '';

    const raw = String(value);
    const cents = raw.includes('.') ? Math.round(numeric * 100) : numeric;
    const currency = window.Shopify?.currency?.active || 'CAD';
    const locale = document.documentElement.lang || 'en-CA';

    try {
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency,
      }).format(cents / 100);
    } catch (error) {
      return `$${(cents / 100).toFixed(2)}`;
    }
  };

  const getRecentSearches = () => {
    try {
      const parsed = JSON.parse(window.localStorage.getItem(RECENT_STORAGE_KEY) || '[]');
      return Array.isArray(parsed)
        ? parsed.filter((item) => typeof item === 'string' && item.trim()).slice(0, RECENT_LIMIT)
        : [];
    } catch (error) {
      return [];
    }
  };

  const saveRecentSearch = (query) => {
    const cleanQuery = String(query || '').trim();
    if (cleanQuery.length < MIN_CHARS) return;

    try {
      const next = [
        cleanQuery,
        ...getRecentSearches().filter((item) => item.toLowerCase() !== cleanQuery.toLowerCase()),
      ].slice(0, RECENT_LIMIT);
      window.localStorage.setItem(RECENT_STORAGE_KEY, JSON.stringify(next));
    } catch (error) {
      // Search still works when storage is unavailable.
    }
  };

  const clearRecentSearches = () => {
    try {
      window.localStorage.removeItem(RECENT_STORAGE_KEY);
    } catch (error) {
      // Ignore storage restrictions.
    }
  };

  const getPredictiveUrl = (query, limit = 4) => {
    const root = window.Shopify?.routes?.root || '/';
    const params = new URLSearchParams();
    params.set('q', query);
    params.set('resources[type]', 'product,collection');
    params.set('resources[limit]', String(limit));
    params.set('resources[limit_scope]', 'each');
    params.set('resources[options][unavailable_products]', 'hide');
    params.set(
      'resources[options][fields]',
      'title,product_type,variants.title,variants.sku,variants.barcode,tag'
    );
    return `${root}search/suggest.json?${params.toString()}`;
  };

  const getQuerySuggestionUrl = (query) => {
    const root = window.Shopify?.routes?.root || '/';
    const params = new URLSearchParams();
    params.set('q', query);
    params.set('resources[type]', 'query');
    params.set('resources[limit]', '2');
    return `${root}search/suggest.json?${params.toString()}`;
  };

  const getSearchPageUrl = (form, query) => {
    const url = new URL(form.action || '/search', window.location.origin);
    url.searchParams.set('q', query);
    url.searchParams.set('options[prefix]', 'last');
    url.searchParams.set('options[unavailable_products]', 'last');
    return url.toString();
  };

  const normalizeQueryText = (querySuggestion) => {
    const text = querySuggestion?.text || querySuggestion?.styled_text || querySuggestion?.styledText || '';
    return String(text).replace(/<[^>]*>/g, '').trim();
  };

  const renderQueryButton = (label, query, modifier = '') => `
    <a
      class="sz-smart-search__chip${modifier ? ` ${modifier}` : ''}"
      href="#"
      data-sz-search-option
      data-sz-query="${escapeHtml(query)}"
      role="option"
      aria-selected="false"
    >${escapeHtml(label)}</a>`;

  const isUsedProduct = (product) => {
    const title = String(product?.title || '').trim().toLowerCase();
    const url = String(product?.url || '').toLowerCase();
    const type = String(product?.product_type || product?.type || '').toLowerCase();
    const tags = Array.isArray(product?.tags)
      ? product.tags.map(tag => String(tag).toLowerCase()).join(' ')
      : String(product?.tags || '').toLowerCase();
    const firstWord = title.split(/\s+/)[0] || '';
    return (
      firstWord === 'used' ||
      title.includes(' used') ||
      /(?:^|\s)-u(?:\s|$|\)|\])/.test(title) ||
      /-u(?:[/?#]|$)/.test(url) ||
      type.includes('used') ||
      tags.includes('used') ||
      tags.includes('trade-in')
    );
  };

  const renderProduct = (product) => {
    const image = normalizeImage(product);
    const price = formatMoney(product?.price_min ?? product?.price);
    const priceMin = Number(product?.price_min);
    const priceMax = Number(product?.price_max);
    const priceVaries =
      product?.price_varies === true ||
      (Number.isFinite(priceMin) && Number.isFinite(priceMax) && priceMax > priceMin);
    const priceLabel = price ? `${priceVaries ? 'From ' : ''}${price}` : '';

    const imageMarkup = image
      ? `<img src="${escapeHtml(image)}" alt="" width="68" height="68" loading="lazy">`
      : '<span class="sz-smart-search__thumb-placeholder">SZ</span>';

    return `
      <a class="sz-smart-search__item" href="${escapeHtml(product?.url || '#')}" data-sz-search-option role="option" aria-selected="false">
        <span class="sz-smart-search__thumb">${imageMarkup}</span>
        <span class="sz-smart-search__info">
          <span class="sz-smart-search__title">${escapeHtml(product?.title || 'Product')}</span>
          ${priceLabel ? `<span class="sz-smart-search__price-row"><span class="sz-smart-search__price">${escapeHtml(priceLabel)}</span></span>` : ''}
        </span>
      </a>`;
  };

  const renderCollection = (collection) => `
    <a class="sz-smart-search__collection" href="${escapeHtml(collection?.url || '#')}" data-sz-search-option role="option" aria-selected="false">
      <span>${escapeHtml(collection?.title || 'Collection')}</span>
    </a>`;

  const findCollectionImage = (collection, products = []) => {
    const directImage = normalizeImage(collection);
    if (directImage) return directImage;
    if (!Array.isArray(products) || !products.length) return '';

    const collectionTokens = String(collection?.title || '')
      .toLowerCase()
      .split(/[^a-z0-9]+/)
      .filter((token) => token.length > 2);

    let bestProduct = null;
    let bestScore = -1;

    products.forEach((product) => {
      const productTitle = String(product?.title || '').toLowerCase();
      const score = collectionTokens.reduce(
        (total, token) => total + (productTitle.includes(token) ? 1 : 0),
        0
      );
      if (score > bestScore && normalizeImage(product)) {
        bestScore = score;
        bestProduct = product;
      }
    });

    return normalizeImage(bestProduct || products[0]);
  };

  const renderCollectionCard = (collection, products = []) => {
    const image = findCollectionImage(collection, products);
    const imageMarkup = image
      ? `<img src="${escapeHtml(image)}" alt="" width="180" height="180" loading="lazy">`
      : '<span class="sz-smart-search__thumb-placeholder">SZ</span>';

    return `
      <a class="sz-smart-search__item sz-smart-search__item--collection-card" href="${escapeHtml(collection?.url || '#')}" data-sz-search-option role="option" aria-selected="false">
        <span class="sz-smart-search__thumb">${imageMarkup}</span>
        <span class="sz-smart-search__info">
          <span class="sz-smart-search__title">${escapeHtml(collection?.title || 'Collection')}</span>
          <span class="sz-smart-search__collection-meta">Shop all sizes</span>
        </span>
      </a>`;
  };

  function initSmartSearch(form, index) {
    if (form.dataset.szSmartSearchReady === 'true') return;

    const input = form.querySelector('input[type="search"][name="q"]');
    if (!input) return;

    const isDesktopHeader = form.matches('[data-sz-header] form.sz-header__desktop-search');
    const isMobilePopupSearch = form.matches('[data-sz-header] form.sz-header__search-form');

    form.dataset.szSmartSearchReady = 'true';
    form.setAttribute('autocomplete', 'off');

    const panel = document.createElement('div');
    panel.className = 'sz-smart-search';
    panel.id = `sz-smart-search-${index}`;
    panel.hidden = true;
    panel.setAttribute('role', 'listbox');
    panel.setAttribute('aria-label', 'Search suggestions');
    panel.setAttribute('aria-busy', 'false');
    form.appendChild(panel);

    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-haspopup', 'listbox');
    input.setAttribute('aria-controls', panel.id);
    input.removeAttribute('aria-owns');
    input.setAttribute('aria-expanded', 'false');
    input.setAttribute('autocomplete', 'off');
    input.setAttribute('autocapitalize', 'off');
    input.setAttribute('spellcheck', 'false');

    let debounceTimer = null;
    let controller = null;
    let renderedQuery = '';
    let activeIndex = -1;

    const options = () => Array.from(panel.querySelectorAll('[data-sz-search-option]'));

    const resetActive = () => {
      activeIndex = -1;
      input.removeAttribute('aria-activedescendant');
      options().forEach((option) => {
        option.classList.remove('is-active');
        option.setAttribute('aria-selected', 'false');
      });
    };

    const setActive = (nextIndex) => {
      const items = options();
      if (!items.length) return;

      activeIndex = ((nextIndex % items.length) + items.length) % items.length;
      items.forEach((option, optionIndex) => {
        if (!option.id) option.id = `${panel.id}-option-${optionIndex}`;
        const isActive = optionIndex === activeIndex;
        option.classList.toggle('is-active', isActive);
        option.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
      const activeOption = items[activeIndex];
      if (activeOption?.id) input.setAttribute('aria-activedescendant', activeOption.id);
      activeOption?.scrollIntoView({ block: 'nearest' });
    };

    const open = () => {
      if (!panel.innerHTML.trim()) return;
      panel.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    };

    const close = () => {
      panel.hidden = true;
      input.setAttribute('aria-expanded', 'false');
      resetActive();
    };

    const loadDesktopPopularCollections = () => {
      if (desktopPopularCollectionsPromise) return desktopPopularCollectionsPromise;

      desktopPopularCollectionsPromise = Promise.all(
        POPULAR_COLLECTIONS.map((item) =>
          fetch(getPredictiveUrl(item.query, 2), { headers: { Accept: 'application/json' } })
            .then((response) => (response.ok ? response.json() : null))
            .then((data) => {
              const products = Array.isArray(data?.resources?.results?.products)
                ? data.resources.results.products.filter((product) => !isUsedProduct(product))
                : [];
              return {
                title: item.label,
                url: item.url,
                image: normalizeImage(products[0]),
              };
            })
            .catch(() => ({
              title: item.label,
              url: item.url,
              image: '',
            }))
        )
      );

      return desktopPopularCollectionsPromise;
    };

    const renderDiscovery = async () => {
      if (isDesktopHeader && window.matchMedia('(min-width: 990px)').matches) {
        panel.innerHTML = `
          <div class="sz-smart-search__heading" role="presentation">Popular collections</div>
          <div class="sz-smart-search__loading" role="presentation">Loading collections…</div>
        `;
        panel.setAttribute('aria-busy', 'true');
        renderedQuery = '';
        resetActive();
        open();

        const collections = await loadDesktopPopularCollections();

        if (document.activeElement !== input || input.value.trim().length >= MIN_CHARS) return;

        panel.innerHTML = `
          <div class="sz-smart-search__heading" role="presentation">Popular collections</div>
          <div class="sz-smart-search__list sz-smart-search__list--popular" role="presentation">
            ${collections.map((collection) => renderCollectionCard(collection)).join('')}
          </div>
        `;

        panel.setAttribute('aria-busy', 'false');
        resetActive();
        open();
        return;
      }

      if (isMobilePopupSearch && window.matchMedia('(max-width: 989px)').matches) {
        panel.innerHTML = `
          <div class="sz-smart-search__heading" role="presentation">Popular collections</div>
          <div class="sz-smart-search__loading" role="presentation">Loading collections…</div>
        `;
        panel.setAttribute('aria-busy', 'true');
        renderedQuery = '';
        resetActive();
        open();

        const collections = await loadDesktopPopularCollections();

        if (document.activeElement !== input || input.value.trim().length >= MIN_CHARS) return;

        panel.innerHTML = `
          <div class="sz-smart-search__heading" role="presentation">Popular collections</div>
          <div class="sz-smart-search__list sz-smart-search__list--mobile-popular" role="presentation">
            ${collections.slice(0, 6).map((collection) => renderCollectionCard(collection)).join('')}
          </div>
        `;

        panel.setAttribute('aria-busy', 'false');
        resetActive();
        open();
        return;
      }

      const recent = getRecentSearches();
      let markup = '<div class="sz-smart-search__discovery" role="presentation">';

      if (recent.length) {
        markup += `
          <div class="sz-smart-search__heading-row" role="presentation">
            <div class="sz-smart-search__heading">Recent searches</div>
            <button class="sz-smart-search__clear" type="button" data-sz-clear-recent>Clear</button>
          </div>
          <div class="sz-smart-search__chips sz-smart-search__chips--recent" role="presentation">
            ${recent.map((query) => renderQueryButton(query, query, 'sz-smart-search__chip--recent')).join('')}
          </div>
          <div class="sz-smart-search__divider" role="presentation"></div>`;
      }

      markup += `
        <div class="sz-smart-search__heading">Popular right now</div>
        <div class="sz-smart-search__chips" role="presentation">
          ${FRESH_SEARCHES.map((item) => renderQueryButton(item.label, item.query)).join('')}
        </div>
      </div>`;

      panel.innerHTML = markup;
      panel.setAttribute('aria-busy', 'false');
      renderedQuery = '';
      resetActive();
      open();
    };

    const render = (data, query) => {
      const results = data?.resources?.results || {};
      const querySuggestions = Array.isArray(results.queries)
        ? results.queries.map(normalizeQueryText).filter(Boolean).slice(0, 2)
        : [];
      const isDesktopGrid = isDesktopHeader && window.matchMedia('(min-width: 990px)').matches;
      const productLimit = isDesktopGrid ? 8 : 4;
      const collectionLimit = isDesktopGrid ? 8 : 1;
      const products = Array.isArray(results.products)
        ? results.products.filter((product) => !isUsedProduct(product)).slice(0, productLimit)
        : [];
      const collections = Array.isArray(results.collections)
        ? results.collections.slice(0, collectionLimit)
        : [];
      const searchPageUrl = getSearchPageUrl(form, query);

      let markup = '';

      if (querySuggestions.length) {
        markup += '<div class="sz-smart-search__heading" role="presentation">Suggested searches</div>';
        markup += '<div class="sz-smart-search__suggestions" role="presentation">';
        markup += querySuggestions
          .map(
            (suggestion) => `
              <a class="sz-smart-search__suggestion" href="#" data-sz-search-option data-sz-query="${escapeHtml(suggestion)}" role="option" aria-selected="false">
                <span class="sz-smart-search__suggestion-icon" aria-hidden="true">↗</span>
                <span>${escapeHtml(suggestion)}</span>
              </a>`
          )
          .join('');
        markup += '</div>';
      }

      if (products.length) {
        if (querySuggestions.length) markup += '<div class="sz-smart-search__divider" role="presentation"></div>';
        markup += '<div class="sz-smart-search__heading" role="presentation">Products</div>';
        markup += '<div class="sz-smart-search__list" role="presentation">';
        markup += products.map(renderProduct).join('');
        markup += '</div>';
      }

      if (!isDesktopGrid && collections.length) {
        if (products.length || querySuggestions.length) {
          markup += '<div class="sz-smart-search__divider" role="presentation"></div>';
        }
        markup += '<div class="sz-smart-search__heading" role="presentation">Collections</div>';
        markup += '<div class="sz-smart-search__list" role="presentation">';
        markup += collections.map(renderCollection).join('');
        markup += '</div>';
      }

      if (!querySuggestions.length && !products.length && (!collections.length || isDesktopGrid)) {
        markup += `<div class="sz-smart-search__empty" role="presentation">No instant product matches for “${escapeHtml(query)}”. Try another model, brand, size, SKU or barcode.</div>`;
      }

      markup += `
        <div class="sz-smart-search__footer" role="presentation">
          <a class="sz-smart-search__view-all" href="${escapeHtml(searchPageUrl)}" data-sz-search-option role="option" aria-selected="false">
            View all results for “${escapeHtml(query)}”
          </a>
        </div>`;

      panel.innerHTML = markup;
      panel.setAttribute('aria-busy', 'false');
      renderedQuery = query;
      resetActive();
      open();
    };

    const search = async (query) => {
      const cleanQuery = query.trim();
      if (cleanQuery.length < MIN_CHARS) {
        controller?.abort();
        renderedQuery = '';
        panel.setAttribute('aria-busy', 'false');
        renderDiscovery();
        return;
      }

      if (cache.has(cleanQuery)) {
        render(cache.get(cleanQuery), cleanQuery);
        return;
      }

      controller?.abort();
      controller = new AbortController();
      panel.setAttribute('aria-busy', 'true');

      try {
        const primaryRequest = fetch(getPredictiveUrl(cleanQuery, isDesktopHeader ? 8 : 4), {
          signal: controller.signal,
          headers: { Accept: 'application/json' },
        }).then((response) => {
          if (!response.ok) throw new Error(`Search request failed: ${response.status}`);
          return response.json();
        });

        const queryRequest = fetch(getQuerySuggestionUrl(cleanQuery), {
          signal: controller.signal,
          headers: { Accept: 'application/json' },
        })
          .then((response) => (response.ok ? response.json() : null))
          .catch((error) => {
            if (error.name === 'AbortError') throw error;
            return null;
          });

        const [data, queryData] = await Promise.all([primaryRequest, queryRequest]);

        if (input.value.trim() !== cleanQuery) return;

        const querySuggestions = queryData?.resources?.results?.queries;
        if (Array.isArray(querySuggestions)) {
          data.resources = data.resources || {};
          data.resources.results = data.resources.results || {};
          data.resources.results.queries = querySuggestions;
        }

        cache.set(cleanQuery, data);
        if (cache.size > 40) cache.delete(cache.keys().next().value);
        render(data, cleanQuery);
      } catch (error) {
        if (error.name === 'AbortError') return;
        panel.setAttribute('aria-busy', 'false');
        console.warn('SportsZone predictive search:', error);
      }
    };

    const applyQuery = (query) => {
      const cleanQuery = String(query || '').trim();
      if (!cleanQuery) return;
      input.value = cleanQuery;
      saveRecentSearch(cleanQuery);
      search(cleanQuery);
      input.focus();
    };

    const queueSearch = () => {
      window.clearTimeout(debounceTimer);
      const query = input.value.trim();

      if (query.length < MIN_CHARS) {
        search(query);
        return;
      }

      debounceTimer = window.setTimeout(() => search(query), DEBOUNCE_MS);
    };

    input.addEventListener('input', queueSearch);

    input.addEventListener('focus', () => {
      const query = input.value.trim();
      if (query.length < MIN_CHARS) {
        renderDiscovery();
        return;
      }
      if (renderedQuery === query && panel.innerHTML.trim()) open();
      else search(query);
    });

    input.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        close();
        return;
      }

      if (panel.hidden) return;

      if (event.key === 'ArrowDown') {
        event.preventDefault();
        setActive(activeIndex + 1);
      } else if (event.key === 'ArrowUp') {
        event.preventDefault();
        setActive(activeIndex <= 0 ? options().length - 1 : activeIndex - 1);
      } else if (event.key === 'Enter' && activeIndex >= 0) {
        const target = options()[activeIndex];
        const targetQuery = target?.dataset?.szQuery;
        if (targetQuery) {
          event.preventDefault();
          applyQuery(targetQuery);
        } else if (target?.href) {
          event.preventDefault();
          saveRecentSearch(input.value.trim());
          window.location.assign(target.href);
        }
      }
    });

    panel.addEventListener('click', (event) => {
      const clearButton = event.target.closest('[data-sz-clear-recent]');
      if (clearButton) {
        event.preventDefault();
        clearRecentSearches();
        renderDiscovery();
        input.focus();
        return;
      }

      const queryButton = event.target.closest('[data-sz-query]');
      if (queryButton) {
        event.preventDefault();
        applyQuery(queryButton.dataset.szQuery);
        return;
      }

      const link = event.target.closest('a[data-sz-search-option]');
      if (link) saveRecentSearch(input.value.trim());
    });

    form.addEventListener('submit', (event) => {
      const query = input.value.trim();
      if (query.length < MIN_CHARS) {
        event.preventDefault();
        renderDiscovery();
        input.focus();
        return;
      }

      saveRecentSearch(query);
      close();
    });

    document.addEventListener('pointerdown', (event) => {
      if (!form.contains(event.target)) close();
    });
  }

  const boot = () => {
    document.querySelectorAll(SEARCH_FORMS).forEach((form, index) => initSmartSearch(form, index));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
